export interface InputDetails {
  key: string;
  type: string;
}

export enum PaymentMethodType {
  Card = 'scheme',
}
export const UnknownCreditCardBrand = 'card';

export interface PaymentMethodDetails {
  details: InputDetails[];
  key: string;
  type: string;
  optional?: boolean;
}

export interface PaymentMethod {
  details: PaymentMethodDetails[];
  name: string;
  type: string;
  brands: string[];
  selected: boolean;
}

export interface PaymentMethodArray {
  paymentMethods: PaymentMethod[];
}
